import React from "react";
import { TESTIMONIALS } from "../homeV2.constants";
import Reveal from "./Reveal";

const Testimonials = () => {
  return (
    <section className="hv2-testimonials" id="testimonials">
      <div className="home-v2__container">
        <Reveal as="span" className="home-v2__label hv2-testimonials__label">
          Real people. Real opportunities.
        </Reveal>
        <Reveal as="h2" delay={0.04} className="home-v2__h2 hv2-testimonials__title">
          What our community <span className="home-v2__highlight">says</span>
        </Reveal>

        <Reveal delay={0.08} className="hv2-testimonials__scroll">
          {TESTIMONIALS.map((testimonial) => (
            <div className="hv2-testimonial-card" key={testimonial.name}>
              <div className="hv2-testimonial-card__quote">&ldquo;{testimonial.quote}&rdquo;</div>
              <div className="hv2-testimonial-card__author">
                <div className="hv2-testimonial-card__av">
                  <img src={testimonial.avatarUrl} alt={testimonial.name} />
                </div>
                <div>
                  <span className="hv2-testimonial-card__name">{testimonial.name}</span>
                  <span className="hv2-testimonial-card__role">{testimonial.role}</span>
                </div>
              </div>
            </div>
          ))}
        </Reveal>
      </div>
    </section>
  );
};

export default Testimonials;
